"use client";

import { useState } from "react";
import { SquareTerminal } from "lucide-react";

import { Button } from "@acme/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@acme/ui/dialog";
import { InputWithCopy } from "@acme/ui/input-with-copy";
import { Label } from "@acme/ui/label";

import { buildRules } from "../../_hooks/ast-grep-hooks";
import { useStudioStore } from "../../_hooks/use-studio-store";

export function RunCliButton() {
  const [isRunCliDialogOpen, setIsRunCliDialogOpen] = useState(false);
  const getCurrentState = useStudioStore((state) => state.getCurrentState);

  const getCliCommand = () => {
    const state = getCurrentState();
    const rules = buildRules({
      config: state.config,
      lang: state.lang,
    });
    const rulesStrings = rules.map((rule) =>
      JSON.stringify(rule).replace(/'/g, "\\'"),
    );

    return `ast-grep scan --report-style=medium --inline-rules '${rulesStrings[0]}' .`;
  };

  return (
    <>
      <Button
        variant={isRunCliDialogOpen ? "secondary" : "ghost"}
        onClick={() => setIsRunCliDialogOpen(true)}
        size="xs"
        aria-label="Run CLI"
      >
        <SquareTerminal className="size-4" />
        <span className="hidden xl:block">Run CLI</span>
      </Button>

      <Dialog open={isRunCliDialogOpen} onOpenChange={setIsRunCliDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Run ast-grep CLI</DialogTitle>
            <DialogDescription>
              Use this command to run ast-grep with your current rules via CLI.
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-2">
            <Label htmlFor="cli-command">CLI Command</Label>
            <InputWithCopy
              id="cli-command"
              value={getCliCommand()}
              placeholder="Generating command..."
              className="font-mono text-sm"
              copySuccessMessage="CLI command copied to clipboard"
              copyErrorMessage="Failed to copy CLI command to clipboard"
            />
          </div>

          <DialogFooter>
            <Button onClick={() => setIsRunCliDialogOpen(false)}>Close</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
